module.exports = __webpack_public_path__ + "static/customer-profiles.84528759.svg";